import React from "react";
import ReactDOM from "react-dom";

const modalRoot = document.getElementById("modal-root") || document.body;

export default function Modal({ isOpen, closeModal, children }) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    // <div className={styles.liningOver}>
    //     <div className={styles.lining} onClick={(e) => e.stopPropagation()} style={{minHeight: '70vh'}}>
    //         <div className={styles.header}>
    //             <h1>{headline}</h1>
    //             <IconContainer Icon={XIcon} onClick={onClose} size = '20' color = 'black' className = '' />
    //         </div>
            <>{React.cloneElement(children, { closeModal })} </>
    //     </div>
    // </div>
    ,
    modalRoot
  );
}
